import { IContractModelingInstructionVersion } from "store/queries/contractModelDrafts";

/** Whether the textarea differs from the saved version (compared trimmed — the server trims). */
export const isInstructionDirty = (
  draft: string,
  latest: IContractModelingInstructionVersion | null
): boolean => draft.trim() !== (latest?.body ?? "").trim();

const formatSavedDate = (iso: string): string =>
  new Date(iso).toLocaleDateString(undefined, { dateStyle: "medium" });

/** "Version 3 · saved Sep 23, 2026 by Ani" — the seeded version has no author. */
export const instructionVersionLine = (
  v: IContractModelingInstructionVersion
): string => {
  const author = v.createdBy
    ? ` by ${v.createdBy.name ?? "a deleted user"}`
    : "";
  return `Version ${v.version} · saved ${formatSavedDate(
    v.createdAt
  )}${author}`;
};

/** The explanation under each contract type's title. */
export const instructionExplanation = (typeLabel: string): string =>
  `Applied to every AI run on a${
    /^[AEIOU]/i.test(typeLabel) ? "n" : ""
  } ${typeLabel} contract, in addition to what you type in the run.`;
